import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export interface PudoAwaitingListHeaderProps {
    title: ReactNode;
    isNewestFirst: boolean;
    onToggleSort: () => void;
}

export const PudoAwaitingListHeader = (props: PudoAwaitingListHeaderProps) => (
    <div className='flex w-full items-center justify-between gap-3'>
        <p className='text-foreground-default min-w-0 flex-1 text-base font-medium'>{props.title}</p>
        <button
            type='button'
            className='text-brand-primary shrink-0 text-sm font-medium'
            onClick={props.onToggleSort}>
            {props.isNewestFirst ? (
                <FormattedMessage
                    id='kiosk.manage-spot.pudo-awaiting-list.sort-newest'
                    description='Sort toggle label when the PuDo awaiting list shows newest transactions first'
                    defaultMessage='Newest first'
                />
            ) : (
                <FormattedMessage
                    id='kiosk.manage-spot.pudo-awaiting-list.sort-oldest'
                    description='Sort toggle label when the PuDo awaiting list shows oldest transactions first'
                    defaultMessage='Oldest first'
                />
            )}
        </button>
    </div>
);
